<template>
  <div class="city-select">
    <el-select
      v-model="prov"
      placeholder="请选择"
      class="input_mm"
      @change="changeSelect"
      :disabled="disabled"
    >
      <el-option v-for="(value, key) in arrCity[0].name" :key="key" :label="value" :value="key"></el-option>
    </el-select>
    <el-select
      v-model="city"
      placeholder="请选择"
      class="input_mm"
      @change="changeSelect"
      :disabled="disabled"
    >
      <el-option v-for="(value, key) in cityArr" :key="key" :label="value" :value="key"></el-option>
    </el-select>
    <el-select
      v-model="district"
      placeholder="请选择"
      class="input_mm"
      @change="changeSelect"
      :disabled="disabled"
    >
      <el-option v-for="(value, key) in districtArr" :key="key" :label="value" :value="key"></el-option>
    </el-select>
  </div>
</template>

<script>
import { selectMenu } from './index';
export default {
  data () {
    return {
      arr: [],
      prov: '',
      cityArr: [],
      city: '',
      district: '',
      districtArr: []
    }
  },
  props: {
    arrCity: {
      type: [Array, Object],
      default: () => {
        return [
          { name: {} }
        ]
      }
    },
    part: {
      type: String,
      default: () => {
        return ''
      }
    },
    defaultCity: {
      type: Object,
      default: () => {
        return {
          prov: '',
          city: '',
          district: ''
        }
      }
    },
    disabled: {
      type: Boolean,
      require: false,
      default: false
    },
    test: {
      type: Object,
      default: () => {
        return {
          name: 'id',
          value: 'hehe'
        }
      }
    }
  },
  computed: {
  },
  methods: {
    updateCity: function () {
      for (var i in this.arrCity) {
        var obj = this.arrCity[i];
        if (obj.value === this.prov) {
          this.cityArr = obj.name;
          break;
        }
      }

      if (Object.keys(this.cityArr).indexOf(this.city) > -1) return false
      let first = Object.keys(this.cityArr).sort((a, b) => a - b)[0]
      // console.log(first, this.cityArr)
      if (this.cityArr && Object.keys(this.cityArr).length > 0 && first) {
        this.city = first;
      } else {
        this.city = '';
      }
    },
    updateDistrict: function () {
      for (var i in this.arrCity) {
        var obj = this.arrCity[i];
        if (obj.value === this.city) {
          this.districtArr = obj.name;
          break;
        }
      }
      if (Object.keys(this.districtArr).indexOf(this.district) > -1) return false
      let first = Object.keys(this.districtArr).sort((a, b) => a - b)[0]
      if (this.districtArr && Object.keys(this.districtArr).length > 0 && first) {
        this.district = first;
      } else {
        this.district = '';
      }
    },
    changeSelect () {
      this.$emit('changeSelect', {
        prov: this.prov,
        city: this.city,
        district: this.district,
        part: this.part
      })
    }
  },
  mounted: function () {
    this.updateCity();
    this.updateDistrict();
  },
  watch: {
    defaultCity (oldValue, newValue) {
      this.prov = this.defaultCity.prov
      this.city = this.defaultCity.city
      this.district = this.defaultCity.district
    },
    prov: function () {
      this.updateCity();
      this.updateDistrict();
    },
    city: function () {
      this.updateDistrict();
    }
  },
  components: {
    selectMenu
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.city-select {
  .input_mm.el-select {
    margin-right: 20px;
    width: 160px;
  }
  .el-input .el-input__icon {
    color: #e21d25;
  }
  .el-input .el-input__inner {
    text-align: center;
  }
  .el-select-dropdown {
    .el-select-dropdown__list {
      .el-select-dropdown__item {
        text-align: center;
      }
      .el-select-dropdown__item.hover,
      .el-select-dropdown__item:hover {
        color: #fff;
        background: #e21d25;
      }
      .el-select-dropdown__item.selected {
        color: #fff;
        background-color: #e21d25;
      }
      .el-select-dropdown__item.selected.hover {
        color: #fff;
        background: #e21d25;
      }
    }
  }
}
</style>
